import i18next from "i18next"
import { mapKeys, size, filter, map } from "lodash"
import { messageBuilder } from '../../constants'
import { dropEmptyKeys, filterNulls } from "../../utils/helper"

/**
 * 
 * @typedef Request
 * @property {String} name
 * @property {Array} channelIds
 * @property {String} communityId
 * @property {Boolean} targetEveryone
 * @property {Boolean} sendReminderDayBefore
 */

/**
 * @typedef ValidationError
 * @property {Boolean} isValid
 * @property {Array} messages
 */


class PostCreateExcelCalendarRequest {

    /**
     * 
     * @param {Request} request
     */
    constructor({
        file,
        channelIds,
        personIds,
        communityId,
    }) {
        this.file = file
        this.personIds = personIds
        this.channelIds = channelIds
        this.communityId = communityId
    }

    /**
     * Post data ready for usage by the API
     * 
     * @returns {Request}
     */
    getPayload = () => {

        // We need to create FormData since the request has to be a multipart/form-data
        const cleaned = this.cleanPayload({
            "file": this.file,
            "community_id": this.communityId,
            "channel_ids": this.channelIds,
            "person_ids": this.personIds,
        })
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('community_id', this.communityId)
        if (cleaned.channel_ids.length > 0) {
            map(cleaned.channel_ids, (id, key) => formData.append(`channel_ids[${key}]`, id))
        }
        
        if (cleaned.person_ids.length > 0) {
            map(cleaned.person_ids, (id, key) => formData.append(`person_ids[${key}]`, id))
        }
        
        if (cleaned.target_everyone) {
            formData.append('target_everyone', cleaned.target_everyone ? 1: 0)
        }

        return formData
    }

    cleanPayload = (payload) => {
       
        // We will remove the special case for targeting all,
        const _channels = filter(payload["channel_ids"], c => c === messageBuilder.TARGET_ALL_TAG_ID)
        const isTargetingAll = (_channels.length > 0)
        
        //? We will also clear any channels and persons selected, although at this points its highly unlikely for these to leak through, good safeguard
        payload["target_everyone"] = isTargetingAll
        
        if (isTargetingAll) {
            payload["person_ids"] = []
            payload["channel_ids"] = []
        }

        return filterNulls(payload)
    }

    /**
     * Determine error messages from the given data if any
     * 
     * @returns {ValidationError}
     */
    validator = () => {

        const errors = []

        if (!this.file) {
            errors.push({
                field: "file",
                isValid: false,
                message: i18next.t("requestObjects.PostCreateNoticeRequest.file.requiredFile")
            })
        }

        return {
            isValid: (errors.length === 0),
            messages: mapKeys(errors, error => error.field)
        }
    }

}

export default PostCreateExcelCalendarRequest